import { Link } from 'react-router-dom';
import AnimSection    from '../components/AnimSection';
import Counter        from '../components/Counter';
import { STATS, STEPS, SERVICES, INDUSTRIES } from '../data';
import heroVideo from '../Elbot Automation.mp4';

/* Wave accent */
function WaveBars() {
  return (
    <div style={{ display:'flex', gap:'3px', alignItems:'center', height:'32px' }}>
      {[1,1.6,.8,1.3,.6,1.4,1,.9].map((h,i) => (
        <div key={i} className="wave-bar" style={{ height:`${h*16}px`, animation:`waveBar ${.8+i*.15}s ease-in-out infinite`, animationDelay:`${i*.1}s`, opacity:.6+i*.04 }} />
      ))}
    </div>
  );
}

export default function Home() {
  return (
    <div className="page-enter">

      {/* ── HERO ─────────────────────────────── */}
      <div style={{ position:'relative', minHeight:'100vh', display:'flex', alignItems:'center', overflow:'hidden', background:'var(--page-hero)' }}>
        <video
          src={heroVideo}
          autoPlay
          muted
          loop
          playsInline
          style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover', zIndex:0, opacity:0.55 }}
        />
        <div style={{ position:'absolute', top:'8%',    right:'4%',  width:'min(520px,55vw)', height:'min(520px,55vw)', background:'radial-gradient(circle,var(--accent-10) 0%,transparent 72%)' }} />
        <div style={{ position:'absolute', bottom:'12%',left:'-3%',  width:'320px',          height:'320px',           background:'radial-gradient(circle,var(--accent-10) 0%,transparent 70%)' }} />

        <div className="sw" style={{ position:'relative', zIndex:2, padding:'9rem clamp(1.2rem,4vw,3rem) 5rem', width:'100%' }}>
          <div style={{ display:'flex', gap:'4rem', alignItems:'center' }}>

            {/* Text side */}
            <div style={{ animation:'fadeUp .75s ease forwards', marginLeft:'auto' }}>
              <div style={{ display:'flex', alignItems:'right', gap:'12px', marginBottom:'1.5rem',paddingRight:'10px', justifyContent:'flex-end' }}>
                <WaveBars />
                <div className="tag">
                  <span style={{ width:'6px', height:'6px', borderRadius:'50%', background:'var(--o)', display:'inline-block', animation:'blink 1.5s infinite' }} />
                  Automation & Controls Specialists
                </div>
              </div>

              <h1 style={{ fontFamily:'var(--fH)', fontSize:'clamp(2.6rem,6vw,5.2rem)', letterSpacing:'2px', lineHeight:.93, color:'var(--dark)', marginBottom:'1.8rem' }}>
                WE POWER<br />
                <span style={{ color:'var(--o)', position:'relative' }}>
                  INDUSTRY
                </span><br />
                TO EXCEL
              </h1>

              <p style={{ color:'#000', maxWidth:'480px', lineHeight:1.8, fontSize:'1.05rem', marginBottom:'2.5rem' }}>
                We create and implement bespoke automation solutions that lower your expenses, eliminate inefficiency, and sharpen your competitive edge across every aspect of production.
              </p>

              <div style={{ display:'flex', gap:'1rem', flexWrap:'wrap', marginBottom:'2.5rem' }}>
                <Link to="/services" className="btn-primary">Explore Services →</Link>
                <Link to="/contact" className="btn-outline">Free Consultation</Link>
              </div>

              {/* Trust badges */}
              <div style={{ display:'flex', gap:'.7rem', flexWrap:'wrap' }}>
                {['ISO 9001','UL 508A','CE Mark','IEC 62443'].map(b => (
                  <span key={b} className="badge" style={{ background:'var(--border-4)', color:'var(--dark)', fontSize:'.9rem' }}>✓ {b}</span>
                ))}
              </div>
            </div>

          </div>

          {/* Stats strip */}
          <div style={{ display:'grid', gridTemplateColumns:'repeat(6,1fr)', gap:'1rem', marginTop:'5.5rem', borderTop:'1px solid var(--border-2)', paddingTop:'2.5rem', animation:'fadeUp .75s .35s ease forwards', opacity:0 }}>
            {STATS.map(s => (
              <div key={s.label} style={{ textAlign:'center' }}>
                <Counter n={s.n} suf={s.suf} />
                <div style={{ color:'var(--dark)', fontSize:'.80rem', letterSpacing:'1px', textTransform:'uppercase', fontFamily:'var(--fM)', marginTop:'.35rem' }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── WHY US ────────────────────────────── */}
      <div style={{ background:'var(--w2)', padding:'6rem clamp(1.2rem,4vw,3rem)' }}>
        <div className="sw">
          <AnimSection style={{ textAlign:'center', marginBottom:'3.5rem' }}>
            <div className="tag" style={{ marginBottom:'1rem' }}>Why Elbot</div>
            <h2 className="section-title">THE <span className="highlight">ELBOT</span> ADVANTAGE</h2>
            <div className="divider" style={{ margin:'1rem auto 0' }} />
          </AnimSection>

          <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'1.5rem' }}>
            {[
              { icon:'🏆', t:'Expertise & Experience',   d:'Certified team with 15+ years of deep industry knowledge and mastery across every major automation platform.' },
              { icon:'🎯', t:'Tailored Solutions',        d:'No off-the-shelf fixes. Every system is designed from scratch around your specific processes and business goals.' },
              { icon:'✅', t:'Quality Assurance',         d:'Rigorous FAT/SAT testing, ISO 9001 quality management, and zero-punch-list commissioning on every project.' },
              { icon:'💡', t:'Innovative Technology',     d:'AI, digital twins, and cloud-connected IIoT — future-proofing your investment from day one.' },
              { icon:'🤝', t:'Support & Optimization',     d:'We provide continuous technical support and system optimization services to ensure your automation systems operate at peak performance with minimal downtime.' },
              { icon:'⏱️', t:'On-Time Delivery',          d:'96% of projects delivered on or ahead of schedule — meticulous planning means your business never waits on us.' },
            ].map((c,i) => (
              <AnimSection key={i} delay={i*.08}>
                <div className="card" style={{ padding:'2rem', height:'100%' }}>
                  <div className="icon-circle" style={{ width:'52px', height:'52px', fontSize:'1.4rem', marginBottom:'1.2rem' }}>{c.icon}</div>
                  <h3 style={{ fontFamily:'var(--fH)', fontSize:'1.2rem', letterSpacing:'1px', marginBottom:'.7rem' }}>{c.t}</h3>
                  <p style={{ color:'var(--mu)', fontSize:'.9rem', lineHeight:1.75 }}>{c.d}</p>
                </div>
              </AnimSection>
            ))}
          </div>
        </div>
      </div>

      {/* ── SERVICES HIGHLIGHTS ───────────────── */}
      <div style={{ background:'var(--w3)', padding:'6rem clamp(1.2rem,4vw,3rem)' }}>
        <div className="sw">
          <AnimSection style={{ marginBottom:'3.5rem' }}>
            <div className="tag" style={{ marginBottom:'1rem' }}>Our Services</div>
            <h2 className="section-title">FROM CONCEPT TO<br /><span className="highlight">COMMISSIONING</span></h2>
            <div className="divider" />
            <p style={{ color:'var(--mu)', maxWidth:'560px', lineHeight:1.8 }}>
              From initial concept to final implementation, we craft, construct, and sustain high-quality automation systems — minimising downtime, improving quality, and cutting energy costs.
            </p>
          </AnimSection>

          <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'1.5rem' }}>
            {SERVICES.slice(0,3).map((s,i) => (
              <AnimSection key={i} delay={i*.1}>
                <div className="card" style={{ padding:'2rem', height:'100%' }}>
                  <div style={{ fontSize:'2.2rem', marginBottom:'1.1rem' }}>{s.icon}</div>
                  <h3 style={{ fontFamily:'var(--fH)', fontSize:'1.25rem', letterSpacing:'1px', marginBottom:'.6rem' }}>{s.title}</h3>
                  <p style={{ color:'var(--mu)', fontSize:'.9rem', lineHeight:1.75, marginBottom:'1.2rem' }}>{s.short}</p>
                  <div style={{ display:'flex', gap:'.4rem', flexWrap:'wrap', marginBottom:'1.2rem' }}>
                    {s.tags.slice(0,3).map(t => <span key={t} className="chip">{t}</span>)}
                  </div>
                  <div style={{ paddingTop:'1rem', borderTop:'1px solid var(--border-6)' }}>
                    <span className="badge" style={{ background:'var(--oL)', color:'var(--o)', border:'1px solid var(--accent-20)' }}>★ {s.highlight}</span>
                  </div>
                </div>
              </AnimSection>
            ))}
          </div>

          <div style={{ textAlign:'center', marginTop:'2.5rem' }}>
            <Link to="/services" className="btn-primary">View All Services →</Link>
          </div>
        </div>
      </div>

      {/* ── PROCESS ───────────────────────────── */}
      <div style={{ background:'var(--w2)', padding:'6rem clamp(1.2rem,4vw,3rem)' }}>
        <div className="sw">
          <AnimSection style={{ textAlign:'center', marginBottom:'3.5rem' }}>
            <div className="tag" style={{ marginBottom:'1rem' }}>How We Work</div>
            <h2 className="section-title">OUR <span className="highlight">PROCESS</span></h2>
            <div className="divider" style={{ margin:'1rem auto 0' }} />
          </AnimSection>

          <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'1.5rem' }}>
            {STEPS.map((s,i) => (
              <AnimSection key={i} delay={i*.08}>
                <div style={{ padding:'2rem', background:i%2===0?'var(--w3)':'var(--w2)', border:'1px solid var(--border-3)', borderRadius:'var(--r2)', position:'relative', height:'100%' }}>
                  <div style={{ fontFamily:'var(--fH)', fontSize:'3.5rem', color:'var(--accent-15)', letterSpacing:'2px', lineHeight:1, marginBottom:'.5rem' }}>{s.n}</div>
                  <h3 style={{ fontFamily:'var(--fH)', fontSize:'1.2rem', letterSpacing:'1px', marginBottom:'.7rem', color:'var(--o)' }}>{s.t}</h3>
                  <p style={{ color:'var(--mu)', fontSize:'.9rem', lineHeight:1.75 }}>{s.d}</p>
                  <div style={{ position:'absolute', top:'1.5rem', right:'1.5rem', width:'28px', height:'28px', borderRadius:'50%', background:'var(--oL)', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'var(--fH)', fontSize:'.85rem', color:'var(--o)' }}>{parseInt(s.n)}</div>
                </div>
              </AnimSection>
            ))}
          </div>
        </div>
      </div>

      {/* ── STATS BAND ──────────────────────────
      <div style={{ background:'var(--o)', padding:'4rem clamp(1.2rem,4vw,3rem)' }}>
        <div className="sw">
          <div style={{ display:'grid', gridTemplateColumns:'repeat(6,1fr)', gap:'1rem' }}>
            {STATS.map(s => (
              <div key={s.label} style={{ textAlign:'center' }}>
                <div style={{ fontFamily:'var(--fH)', fontSize:'clamp(1.8rem,3.5vw,2.8rem)', color:'var(--white)', letterSpacing:'2px' }}>
                  <Counter n={s.n} suf={s.suf} />
                </div>
                <div style={{ color:'var(--white-70)', fontSize:'.72rem', letterSpacing:'1.5px', textTransform:'uppercase', fontFamily:'var(--fM)', marginTop:'.3rem' }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div> */}

      {/* ── INDUSTRIES SNAP ───────────────────── */}
      <div style={{ background:'var(--w3)', padding:'6rem clamp(1.2rem,4vw,3rem)' }}>
        <div className="sw">
          <AnimSection style={{ marginBottom:'3.5rem' }}>
            <div className="tag" style={{ marginBottom:'1rem' }}>Industries We Serve</div>
            <h2 className="section-title">TRANSFORMING THE<br /><span className="highlight">WORLD'S LEADING</span> COMPANIES</h2>
            <div className="divider" />
          </AnimSection>

          <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'1.2rem' }}>
            {INDUSTRIES.map((ind,i) => (
              <AnimSection key={i} delay={i*.07}>
                <div className="card" style={{ padding:'1.8rem', display:'flex', gap:'1rem', alignItems:'flex-start' }}>
                  <div className="icon-circle" style={{ width:'46px', height:'46px', fontSize:'1.3rem', flexShrink:0 }}>{ind.icon}</div>
                  <div>
                    <h3 style={{ fontFamily:'var(--fH)', fontSize:'1.1rem', letterSpacing:'1px', marginBottom:'.5rem' }}>{ind.name}</h3>
                    <p style={{ color:'var(--mu)', fontSize:'.85rem', lineHeight:1.7 }}>{ind.desc}</p>
                  </div>
                </div>
              </AnimSection>
            ))}
          </div>

          <div style={{ textAlign:'center', marginTop:'2.5rem' }}>
            <Link to="/industries" className="btn-outline">View All Industries →</Link>
          </div>
        </div>
      </div>

      {/* ── FINAL CTA ─────────────────────────── */}
      <div style={{ background:'var(--dark)', padding:'5rem clamp(1.2rem,4vw,3rem)' }}>
        <div className="sw" style={{ textAlign:'center' }}>
          <AnimSection>
            <div className="tag" style={{ marginBottom:'1.5rem', background:'var(--oL)', borderColor:'var(--accent-35)', color:'var(--o2)' }}>Ready to Automate?</div>
            <h2 style={{ fontFamily:'var(--fH)', fontSize:'clamp(2.5rem,5vw,4.5rem)', letterSpacing:'3px', color:'var(--white)', marginBottom:'1rem' }}>
              TAKE YOUR OPERATIONS<br />TO THE <span style={{ color:'var(--o)' }}>NEXT LEVEL</span>
            </h2>
            <p style={{ color:'#8a8278', maxWidth:'500px', margin:'0 auto 2.5rem', lineHeight:1.8 }}>
              Contact us today to learn how Elbot Automation can help you achieve your industrial automation goals. Our team is ready with expert advice and bespoke solutions.
            </p>
            <div style={{ display:'flex', gap:'1rem', justifyContent:'center', flexWrap:'wrap' }}>
              <Link to="/contact"  className="btn-primary" style={{ fontSize:'1.1rem', padding:'15px 36px' }}>Get a Free Quote →</Link>
              <Link to="/services" className="btn-outline" style={{ borderColor:'var(--white-25)', color:'var(--white)' }}>View Services</Link>
            </div>
          </AnimSection>
        </div>
      </div>

    </div>
  );
}
